<template>
  <v-container fill-height grid-list-lg wrap>
    <v-layout align-start justify-center px-5 pb-5 wrap>
      <v-flex lg8 sm10 xs12 px-4>
        <p class="headline" style="margin-left: -8px">{{chapter.title}}</p>
        <p
          v-if="chapter.description"
          class="header disabled--text"
          style="margin-left: -8px"
        >{{ chapter.description }}</p>
        <lister
          style="height: 100%"
          :items="shownContents"
          cardBreakpoints="xs12 md6"
          searchPlaceholder="Buscar por título"
          :customSearchFunction="search"
          :autosort="false"
        >
          <template v-slot:default="slotProps">
            <content-row
              class="ma-1"
              :content="slotProps.item"
              :index="slotProps.index"
              @didTapItem="didTapItem"
            />
          </template>
        </lister>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Lister from '@/components/Lister.vue';
import { db } from '@/firebase/config';
import ContentRow from './contentRow.vue';

export default {
  components: { ContentRow, Lister },

  mounted() {
    this.$bind('chapter', db.doc(`chapters/${this.$route.params.chapterID}`));
    this.$bind('contents', db.collection(`chapters/${this.$route.params.chapterID}/contents`));
  },
  data: () => ({
    contents: [],
    chapter: {},
  }),
  methods: {
    didTapItem(item) {
      this.$router.push({
        name: 'content',
        params: { chapterID: this.$route.params.chapterID, contentID: item.id },
      });
    },
  },
  computed: {
    shownContents() {
      if (this.chapter == null) {
        return [];
      }
      const shown = this.contents.slice();
      shown.sort(this.sortContents);
      return shown;
    },
    sortContents() {
      return (a, b) => {
        const contentOrder = this.chapter.contentOrder || [];
        const indexA = contentOrder.indexOf(a.id);
        const indexB = contentOrder.indexOf(b.id);
        return indexA - indexB;
      };
    },
    search() {
      return (item, searchString) => item.title.toLowerCase().includes(searchString.toLowerCase());
    },
    icon() {
      if (this.chapter) {
        if (this.chapter.icon) {
          return this.chapter.icon;
        }
        return 'insert_drive_file';
      }
      return 'timer';
    },
    title() {
      if (this.chapter) {
        if (this.chapter.title) {
          return this.chapter.title;
        }
      }
      return 'Carregando...';
    },
  },
};
</script>
